define([
	"dojo/_base/declare",
	"csi/switchboard/ViewMixin",
	"./View"
], function(declare,ViewMixin,View) {

	return declare([View, ViewMixin], {
		_types: ["TableSwitchboard", "Table"],
		
		constructor: function(def) {
			this._initSwitchboard(def);
		}
	});
});